const isPlayed = (f) =>
  f?.is_forfeit === true ||
  f?.game_played === true ||
  (f?.home_team_score != null && f?.away_team_score != null);

/**
 * One entry per fixture date, in order: `{ date, matchday, games, played, status }`.
 * `status` is "played" (every game has a result), "partial" or "upcoming".
 */
export function listMatchdays(fixtures) {
  const byDate = new Map();
  for (const f of fixtures || []) {
    if (!f?.date) continue;
    const row = byDate.get(f.date) || { date: f.date, games: 0, played: 0 };
    row.games += 1;
    if (isPlayed(f)) row.played += 1;
    byDate.set(f.date, row);
  }
  return [...byDate.values()]
    .sort((a, b) => a.date.localeCompare(b.date))
    .map((row, i) => ({
      ...row,
      matchday: i + 1,
      status: row.played === row.games ? "played" : row.played > 0 ? "partial" : "upcoming",
    }));
}

/**
 * Matchday to open on: today if there are games today, else the next upcoming date,
 * else the most recent one (season finished).
 */
export function defaultMatchdayDate(matchdays, todayKey) {
  if (!matchdays?.length) return null;
  if (matchdays.some((m) => m.date === todayKey)) return todayKey;
  const next = matchdays.find((m) => m.date > todayKey);
  return (next || matchdays[matchdays.length - 1]).date;
}
